import * as React from 'react'
import { Button } from '@repo/studio-design-system-ui-button'

import { SheetClose, SheetContent, SheetRoot, SheetTrigger } from '../sheet'
import { SheetContentBoundary } from '../sheet-content-boundary'

interface LeftSheetProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  trigger?: React.ReactNode
  children: React.ReactNode
  showCloseButton?: boolean
  className?: string
  style?: React.CSSProperties
  overlayClassName?: string
  overlayStyle?: React.CSSProperties
  modal?: boolean
}

export function LeftSheet({
  open,
  onOpenChange,
  trigger,
  children,
  showCloseButton = false,
  className,
  style,
  overlayClassName,
  overlayStyle,
  modal = true,
}: LeftSheetProps) {
  const [internalOpen, setInternalOpen] = React.useState(false)

  const isControlled = open !== undefined
  const isOpen = isControlled ? open : internalOpen

  const handleOpenChange = (newOpen: boolean) => {
    if (!isControlled) {
      setInternalOpen(newOpen)
    }
    onOpenChange?.(newOpen)
  }

  return (
    <SheetRoot open={isOpen} onOpenChange={handleOpenChange} modal={modal}>
      {trigger ? <SheetTrigger asChild>{trigger}</SheetTrigger> : null}

      <SheetContent
        direction="left"
        showCloseButton={showCloseButton}
        className={className}
        overlayClassName={overlayClassName}
        overlayStyle={overlayStyle}
        style={style}
      >
        <SheetContentBoundary>{children}</SheetContentBoundary>

        {showCloseButton ? (
          <SheetClose asChild>
            <Button variant="primary">Close</Button>
          </SheetClose>
        ) : null}
      </SheetContent>
    </SheetRoot>
  )
}
